import { render, staticRenderFns } from "./SidebarModal.vue?vue&type=template&id=2277a340&scoped=true"
import script from "./SidebarModal.vue?vue&type=script&lang=js"
export * from "./SidebarModal.vue?vue&type=script&lang=js"
import style0 from "./SidebarModal.vue?vue&type=style&index=0&id=2277a340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277a340",
  null
  
)

export default component.exports